import { Text, Box } from "@vinomofo/components";
import { COLORS, FONT_FAMILIES } from "../../styles";
import { Testimonial } from "./testimonialData";
import styled from "styled-components";

const { dmSans } = FONT_FAMILIES;

interface TestimonialCardProps {
  testimonial: Testimonial;
}

const getJoinedDate = (dateString: string): string => {
  const date = new Date(dateString);
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  return `Joined ${month}, ${year}`;
};

const ReviewCard = styled(Box)`
  padding: 50px 40px 30px;
  border-radius: 12px;
  background-color: #181717;
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;

  @media ${({ theme }) => theme.mq.max.mobile} {
    padding: 25px 25px 20px;
  }

  &:hover {
    border-color: ${COLORS.liquidGold};
    box-shadow: 0 10px 50px rgba(255, 255, 255, 0.1);
  }
`;

const ImageWrapper = styled(Box)`
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
`;

const CardContent = styled(Box)`
  flex: 1;
  width: 100%;
  margin-top: 30px;
`;

const CardFooter = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: auto;
  width: 100%;
  padding-top: 10px;
`;

const Avatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ReviewerInfo = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const TestimonialCard = ({ testimonial }: TestimonialCardProps) => {
  const { text, author, date, avatar } = testimonial;
  const formattedDate = getJoinedDate(date);

  return (
    <ReviewCard>
      <ImageWrapper>
        <Avatar src={avatar} alt={author} />
      </ImageWrapper>
      <CardContent>
        <Box style={{ marginBottom: 16 }}>
          <Text
            as="h3"
            fontFamily={dmSans}
            fontSize={["16px", "18px"]}
            fontWeight="bold"
            color="white"
          >
            {text}
          </Text>
        </Box>
      </CardContent>

      <CardFooter>
        <ReviewerInfo>
          <Box>
            <Text
              fontFamily={dmSans}
              fontSize="15px"
              color="white"
              fontWeight="normal"
            >
              {author}
            </Text>
            <Text fontFamily={dmSans} fontSize="14px" color="dorianGray">
              {formattedDate}
            </Text>
          </Box>
        </ReviewerInfo>
      </CardFooter>
    </ReviewCard>
  );
};
